<template>
  <Card
    class="text-center flex flex-col gap-4"
    v-if="!emotes || emotes?.length"
  >
    <h1 class="text-lg font-bold tracking-wide">Emotes</h1>
    <slot name="description" v-if="description || $slots.description">
      <p>{{ description }}</p>
    </slot>

    <div
      v-if="emotes"
      class="mt-auto fan-out group overflow-hidden rounded-lg aspect-video select-none flex items-center justify-center gap-4"
      :class="{
        subscribe: subscribeLink,
        'stage-gradient-nami': !subscribeLink,
        'stage-gradient-yellow': subscribeLink,
      }"
      role="button"
      @click="showAll = true"
    >
      <EmoteImage
        v-for="emote in emotes.slice(0, 5)"
        :emote="emote"
        class="w-[20%] aspect-1/1 pointer-events-none h-auto"
      />
    </div>
    <Skeleton v-else class="aspect-video" />
    <NamiModal v-model="showAll" large>
      <NamiModalTitle @close="showAll = false">All Emotes</NamiModalTitle>
      <div
        class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4"
      >
        <div v-for="emote in emotes || []">
          <EmoteImage :emote="emote" class="w-full h-auto aspect-1/1 m-auto" />
          <h4 class="text-center mt-1 truncate font-bold">
            {{ emote.attributes.name }}
          </h4>
          <h5 class="text-center truncate text-sm">
            :{{ emote.attributes.key }}:
          </h5>
        </div>
      </div>
    </NamiModal>
  </Card>
</template>

<script setup lang="ts">
import type { EmoteEntity } from "~/src/api";

defineProps<{
  emotes?: EmoteEntity[] | false | null;
  subscribeLink?: string;
  description?: string;
}>();

const showAll = ref(false);
</script>

<style scoped lang="postcss">
.fan-out {
  @apply relative;

  & > img {
    top: 50%;
    left: 50%;
    @apply absolute drama-nami-nami-blue drama-3;
  }

  &.subscribe > img {
    @apply drama-yellow-400;
  }

  & > :nth-child(1) {
    transform: translateX(-50%) translateY(-125%);
  }
  & > :nth-child(2) {
    transform: translateX(-195%) translateY(-95%) rotate(-15deg);
  }
  & > :nth-child(3) {
    transform: translateX(95%) translateY(-95%) rotate(15deg);
  }
  & > :nth-child(4) {
    transform: translateX(-125%) translateY(20%) rotate(-5deg);
  }
  & > :nth-child(5) {
    transform: translateX(25%) translateY(20%) rotate(5deg);
  }
}
</style>
